<template>
  <section class="bg-white">
    <div id="fb-root"></div>
    <div class="menu-header">
      <div class="header-top">
        <div class="header-left">
          <Tag type="primary"
               outline
               size="small"
               class="mr-4"
               v-if=" bindData && catNm">
            {{ catNm }}
          </Tag>
          <div class="menu-id" v-if="bindData">
            メニューNo. {{ bindData.menuNo }}
          </div>
        </div>
        <div class="header-right">
          <div class="header-share">
            <Share />
          </div>
        </div>
      </div>  
      <h2 class="menu-title" v-if="bindData">
      <a-tooltip>
        <template slot="title">
          {{ bindData.menuNm | capitalize }}
        </template>
      {{ bindData.menuNm | capitalize }}
      </a-tooltip>
      </h2>
      <div class="header-meta">
        <div class="meta-item inline-flex"  v-if="bindData && areaName ">
          <i class="icon icon-bor-pin pt-1 pr-2" />
          <span>
            {{areaName}}
          </span>
        </div>
        <button class="c-btn btn-white btn-sm ml-4" @click="gotoMap" v-if="hasCoordinates">
          地図を見る
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import _ from 'lodash'
import Tag from '@/components/primitive/Tag'
import { SAVE_FAVORITE, GET_STATUS_FAVORITE, DELETE_FAVORITE } from '@/store/modules/bs_myp/actions'

export default {
  name: 'MenuDetailHeader',
  components: {
    Tag
  },
  props: ['value'],
  data() {
    return {
      inWishList: false,
      bindData: null,
      showPopup: false,
      dataItemOrder: '',
      catNm: '',
      catLrgClassNm: '',
      catMidClassNm: '',
      catSmlClassNm: '',
      areaName: '',
      areaMidClassNm: '',
      areaDtlClassNm: ''
    }
  },
  beforeMount() {
    this.bindData = this.value
    this.dataItemOrder = this.value
  },
  mounted() {
    this.getStatusFavorite()
  },
  
  watch: {
    value(val) {
      this.bindData = val
      this.getDataClone()
      this.getCatNm()
      this.getAreaName()
    }
  },
  
  methods: {
    getDataClone() {
      this.dataItemOrder = _.cloneDeep(this.bindData)
    },
    getCatNm() {
      this.getDataClone()
      this.catLrgClassNm = _.get(this.dataItemOrder, 'categoryInfomation.catLrgClassNm', '')
      this.catMidClassNm = _.get(this.dataItemOrder, 'categoryInfomation.catMidClassNm', '')
      this.catSmlClassNm = _.get(this.dataItemOrder, 'categoryInfomation.catSmlClassNm', '')
      if(this.catLrgClassNm === '' && this.catMidClassNm === '' && this.catSmlClassNm !== '') {
        this.catNm = `${this.catSmlClassNm}`
      }
      if(this.catLrgClassNm === '' && this.catMidClassNm !== '' && this.catSmlClassNm === '') {
        this.catNm = `${ this.catMidClassNm}`
      }
      if(this.catLrgClassNm !== '' && this.catMidClassNm === '' && this.catSmlClassNm !== '') {
        this.catNm = `${ this.catLrgClassNm}`
      }
      if(this.catLrgClassNm === '' && this.catMidClassNm !== '' && this.catSmlClassNm !== '') {
        this.catNm = `${this.catMidClassNm  }・${ this.catSmlClassNm}`
      }
      if(this.catLrgClassNm !== '' && this.catMidClassNm === '' && this.catSmlClassNm !== '') {
        this.catNm = `${this.catLrgClassNm  }・${ this.catSmlClassNm}`
      }
      if(this.catLrgClassNm !== '' && this.catMidClassNm !== '' && this.catSmlClassNm === '') {
        this.catNm = `${this.catLrgClassNm  }・${ this.catMidClassNm}`
      }
      if(this.catLrgClassNm !== '' && this.catMidClassNm !== '' && this.catSmlClassNm !== '') {
        this.catNm = `${this.catLrgClassNm  }・${  this.catMidClassNm  }・${ this.catSmlClassNm}`
      }
    },
    getAreaName() {
      this.getDataClone()
      this.areaMidClassNm = _.get(this.dataItemOrder, 'areaInfomation.areaMidClassNm', '')
      this.areaDtlClassNm = _.get(this.dataItemOrder, 'areaInfomation.areaDtlClassNm', '')
      if(this.areaMidClassNm !== '' && this.areaDtlClassNm === '') {
        this.areaName = `${this.areaMidClassNm}`
      }
      if(this.areaMidClassNm === '' && this.areaDtlClassNm !== '') {
        this.areaName = `${this.areaDtlClassNm}`
      }
      if(this.areaMidClassNm !== '' && this.areaDtlClassNm !== '') {
        this.areaName = `${this.areaMidClassNm}・${this.areaDtlClassNm}`
      }
      return this.areaName
    },
    gotoMap() {
      if (this.bindData && this.bindData.areaInfomation) {
        const { latitude, longitude } = this.bindData.areaInfomation
        if(latitude && longitude) {
          window.open(`https://maps.google.com/?q=${latitude},${longitude}`)
        }
        return
      }
      window.open('https://maps.google.com')
    },
    copyContent() {
      return location.href
    },
    copySuccess() {
      this.$toasted.success('Copied')
    },
    copyError() {
      this.$toasted.error('Copy failed')
    },
    checkLogin() {
      const query = this.$route.query
      const data = {
        itemType: 'favourite', 
        menuNo: query.menuNo
      }

      if(this.statusFavorite) {
        this.$store.dispatch(DELETE_FAVORITE, this.idFavorite).then(
          () => {
            this.statusFavorite = false
            // this.getStatusFavorite()
          },
          (error) => {
            this.$toasted.error(error && error.message ? error.message : error)
          }
        )
      } else {
        this.$store.dispatch(SAVE_FAVORITE, data).then(
          (result) => {
            this.idFavorite = _.get(result, 'id', '')
            this.statusFavorite = true
            // this.getStatusFavorite()
          },
          (error) => {
            this.$toasted.error(error && error.message ? error.message : error)
          }
        )
      }
    },
    getStatusFavorite() {
      const query = this.$route.query
      const params = {
        menuNo: query.menuNo
      }
      this.$store.dispatch(GET_STATUS_FAVORITE, params).then(
        (data) => {
          if (data) {
            this.statusFavorite = _.get(data, 'data.favourite', '')
            this.idFavorite = _.get(data, 'data.id', '')
          }
        },
        (error) => {
          this.$toasted.error(error && error.message ? error.message : error)
        }
      )
    }
  },
  computed: {
    getUserInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'auth', null))
    },
    hasCoordinates() {
      return _.get(this.bindData, 'areaInfomation.latitude', null) && _.get(this.bindData, 'areaInfomation.longitude', null)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
